// import './input.scss';

export { default } from './Input';
export { default as template } from './input.tpl';
